function PkDocState(id, caption) {
  this.id = id;
  this.caption = caption;
}

export class CdDocStates {

        /// <summary>
        /// Проект
        /// </summary>
        static Project = new PkDocState(0, "Проект");

        /// <summary>
        /// На рассмотрении УКС
        /// </summary>
        static UksApproval = new PkDocState(1, "На рассмотрении УКС");

        /// <summary>
        /// На рассмотрении во внешней организации
        /// </summary>
        static ExternalOrganizationApproval = new PkDocState(2, "На рассмотрении во внешней организации");

        /// <summary>
        /// На доработке
        /// </summary>
        static Rework = new PkDocState(3, "На доработке");

        /// <summary>
        /// Неактуален
        /// </summary>
        static Irrelevant = new PkDocState(4, "Неактуален");

        /// <summary>
        /// Отменен
        /// </summary>
        static Canceled = new PkDocState(5, "Отменен");

        /// <summary>
        /// Выдано в производство работ
        /// </summary>
        static Production = new PkDocState(6, "Выдано в производство работ");

        /// <summary>
        /// На рассмотрении ПГ заказчика
        /// </summary>
        static PgApproval = new PkDocState(7, "На рассмотрении ПГ заказчика");

        /// <summary>
        /// На рассмотрении ГИП
        /// </summary>
        static GipApproval = new PkDocState(8, "На рассмотрении ГИП");

        /// <summary>
        /// На рассмотрении ОСП
        /// </summary>
        static OspApproval = new PkDocState(9, "На рассмотрении ОСП");

        /// <summary>
        /// На рассмотрении
        /// </summary>
        static Consideration = new PkDocState(10, "На рассмотрении");

        /// <summary>
        /// На исполнении
        /// </summary>
        static Performance = new PkDocState(11, "На исполнении");

        /// <summary>
        /// Завершен
        /// </summary>
        static Complete = new PkDocState(12, "Завершен");

        /// <summary>
        /// На согласовании
        /// </summary>
        static Agreement = new PkDocState(13, "На доп. согласовании");

        /// <summary>
        /// На подписании
        /// </summary>
        static Signing = new PkDocState(14, "На подписании");

        /// <summary>
        /// Подготовка к подписанию
        /// </summary>
        static PreparationForSigning = new PkDocState(15, "Подготовка к подписанию");

        /// <summary>
        /// На согласовании в Удо
        /// </summary>
        static AgreementUdo = new PkDocState(16, "На согласовании в УДО");

        /// <summary>
        /// На согласовании у руководителя
        /// </summary>
        static AgreementManager = new PkDocState(17, "На согласовании у руководителя");

        /// <summary>
        /// Не подписан
        /// </summary>
        static NotSigned = new PkDocState(18, "Не подписан");

        /// <summary>
        /// На проверке
        /// </summary>
        static OnCheck = new PkDocState(19, "На проверке");

        /// <summary>
        /// Подписан
        /// </summary>
        static Signed = new PkDocState(20, "Подписан");

        /// <summary>
        /// Отклонен
        /// </summary>
        static Rejected = new PkDocState(21, "Отклонен");

        /// <summary>
        /// На согласовании у исполнителя
        /// </summary>
        static AgreementPerformer = new PkDocState(22, "На согласовании у исполнителя");

        /// <summary>
        /// На регистрации
        /// </summary>
        static OnRegistration = new PkDocState(23, "На регистрации");

        /// <summary>
        /// Зарегистрирован
        /// </summary>
        static Registered = new PkDocState(24, "Зарегистрирован");

        /// <summary>
        /// На согласовании в ЮД
        /// </summary>
        static AgreementLegalDepartment = new PkDocState(25, "На согласовании в ЮД");

        /// <summary>
        /// Действующий
        /// </summary>
        static Active = new PkDocState(26, "Действующий");

        /// <summary>
        /// На согласовании ПГ заказчика
        /// </summary>
        static AgreementPgCustomer = new PkDocState(27, "На согласовании ПГ заказчика");

        /// <summary>
        /// Согласован
        /// </summary>
        static Agreed = new PkDocState(28, "Согласован");

        /// <summary>
        /// Зарегистрировано
        /// </summary>
        static RegisteredLC = new PkDocState(29, "Зарегистрировано");

        /// <summary>
        /// На согласовании в Департаменте закупок
        /// </summary>
        static AgreementPurchasingDepartment = new PkDocState(30, "На согласовании в Департаменте закупок");

        /// <summary>
        /// На согласовании с нач. УДО
        /// </summary>
        static AgreementHeadUDO = new PkDocState(31, "На согласовании с нач. УДО");

        /// <summary>
        /// Загрузка скан-копии
        /// </summary>
        static DownloadScanCopy = new PkDocState(32, "Загрузка скан-копии");

        /// <summary>
        /// Загружен в 1С
        /// </summary>
        static UploadedToTUS = new PkDocState(33, "Загружен в 1С");

        /// <summary>
        /// Ожидает отправки
        /// </summary>
        static WaitingForSending = new PkDocState(34, "Ожидает отправки");

        /// <summary>
        /// Исполнен
        /// </summary>
        static Fulfilled = new PkDocState(35, "Исполнен");

        /// <summary>
        /// Отправлен
        /// </summary>
        static Sent = new PkDocState(36, "Отправлен");

        /// <summary>
        /// На отправку
        /// </summary>
        static ToSend = new PkDocState(37, "На отправку");

        /// <summary>
        /// На согласовании
        /// </summary>
        static OnAgreement = new PkDocState(38, "На согласовании");

        /// <summary>
        /// На подготовке к подписанию
        /// </summary>
        static InPreparationForSigning = new PkDocState(39, "На подготовке к подписанию");

        /// <summary>
        /// Рассмотрена
        /// </summary>
        static Considered = new PkDocState(40, "Рассмотрена");

        /// <summary>
        /// Отклонена
        /// </summary>
        static Disapproved = new PkDocState(41, "Отклонена");

        /// <summary>
        /// Исполнена
        /// </summary>
        static Executed = new PkDocState(42, "Исполнена");

        /// <summary>
        /// На утверждении
        /// </summary>
        static OnApproval = new PkDocState(43, "На утверждении");

        /// <summary>
        /// На согласовании в ОСП
        /// </summary>
        static AgreementOSP = new PkDocState(44, "На согласовании в ОСП");


        /// <summary>
        /// На согласовании у Вице-президента
        /// </summary>
        static AgreementHead = new PkDocState(45, "На согласовании у Вице-президента");


        /// <summary>
        /// Перенесено из СКП
        /// </summary>
        static TransformSKP = new PkDocState(46, "Перенесено из СКП");

        /// <summary>
        /// Утвержден
        /// </summary>
        static Approval = new PkDocState(47, "Утвержден");

        /// <summary>
        /// Архив
        /// </summary>
        static Archive = new PkDocState(48, "Архив");

        /// <summary>
        /// Передано заказчику
        /// </summary>
        static TransferredToCustomers = new PkDocState(49, "Передано заказчику");

        /// <summary>
        /// На согласовании объемов работ
        /// </summary>
        static AgreementScopeWork = new PkDocState(50, "На согласовании объемов работ");

        /// <summary>
        /// Согласование НЗ
        /// </summary>
        static AgreementNZ = new PkDocState(51, "Согласование НЗ");

        /// <summary>
        /// На согласовании у бухгалтера
        /// </summary>
        static AgreementAccountant = new PkDocState(52, "На согласовании у бухгалтера");

        /// <summary>
        /// На согласовании калькуляции
        /// </summary>
        static AgreementCalculation = new PkDocState(53, "На согласовании калькуляции");

        /// <summary>
        /// У подписанта
        /// </summary>
        static AtTheSigner = new PkDocState(54, "У подписанта");

        /// <summary>
        /// Формирование калькуляции
        /// </summary>
        static FormationCosting = new PkDocState(55, "Формирование калькуляции");

        /// <summary>
        /// Получен, подпись не требуется
        /// </summary>
        static Received = new PkDocState(56, "Получен, подпись не требуется");

        /// <summary>
        /// Ожидает подписания
        /// </summary>
        static WaitingForDiadocResult = new PkDocState(57, "Ожидает подписания");

        /// <summary>
        /// Подписано извещение о получении
        /// </summary>
        static WorkflowCompleted = new PkDocState(58, "Подписано извещение о получении");

        /// <summary>
        /// У ответственного за распределение акта"
        /// </summary>
        static AtTheResponsibleForAct = new PkDocState(59, "У ответственного за распределение акта");

        /// <summary>
        /// Подтверждение Наряд-заказа
        /// </summary>
        static OrderTicketConfirmation = new PkDocState(60, "Подтверждение Наряд-заказа");

        /// <summary>
        /// Перемещен в удаленные
        /// </summary>
        static MovedToRemote = new PkDocState(61, "Перемещен в удаленные");

        /// <summary>
        /// Аннулирован
        /// </summary>
        static Revocated = new PkDocState(62, "Аннулирован");

        /// <summary>
        /// Черновик
        /// </summary>
        static Draft = new PkDocState(63, "Черновик");

        /// <summary>
        /// На согласование Подрядчика
        /// </summary>
        static OnApprovalContractor = new PkDocState(64, "На согласование Подрядчика");

        /// <summary>
        /// На согласовании у экономиста
        /// </summary>
        static OnApprovalEconomist = new PkDocState(65, "На согласовании у экономиста");

        /// <summary>
        /// На доп.согласовании у Заказчика
        /// </summary>
        static OnAdditionalApprovalCustomer = new PkDocState(66, "На доп.согласовании у Заказчика");

        /// <summary>
        /// На согласование ГП
        /// </summary>
        static OnApprovalGP = new PkDocState(67, "На согласование ГП");

        /// <summary>
        /// На согласовании - Заказчик
        /// </summary>
        static OnApprovalCustomer = new PkDocState(68, "На согласовании - Заказчик");

        /// <summary>
        /// На согласовании - Эксплуатирующая организация
        /// </summary>
        static OnApprovalOperatingOrganization = new PkDocState(69, "На согласовании - Эксплуатирующая организация");

        /// <summary>
        /// Ожидает принятия к учету
        /// </summary>
        static WaitingForAccounting = new PkDocState(70, "Ожидает принятия к учету");

        /// <summary>
        /// Не актуальна
        /// </summary>
        static NotRelevant = new PkDocState(71, "Не актуальна");

        /// <summary>
        /// На согласование ГП исполнителя работ
        /// </summary>
        static OnApprovalGPExecutorWorks = new PkDocState(72, "На согласование ГП исполнителя работ");

        /// <summary>
        /// На согласовании в УБК
        /// </summary>
        static OnApprovalUBK = new PkDocState(73, "На согласовании в УБК");

        /// <summary>
        /// На согласовании - Авторский надзор
        /// </summary>
        static OnApprovalAuthorSupervision = new PkDocState(74, "На согласовании - Авторский надзор");

        /// <summary>
        /// На подписании и сканировании
        /// </summary>
        static OnSigningAndScanning = new PkDocState(75, "На подписании и сканировании");

        /// <summary>
        /// Организация подписания и сканирования
        /// </summary>
        static OrganizationSigningAndScanning = new PkDocState(76, "Организация подписания и сканирования");

        /// <summary>
        /// Подтверждение получения оригинала
        /// </summary>
        static OnConfirmation = new PkDocState(77, "Подтверждение получения оригинала");

        /// <summary>
        /// На согласовании у Заказчика
        /// </summary>
        static OnApprovalWithTheCustomer = new PkDocState(78, "На согласовании у Заказчика");

        /// <summary>
        /// Согласование стоимости
        /// </summary>
        static ApproveOfCost = new PkDocState(79, "Согласование стоимости");

        /// <summary>
        /// Согласование объемов
        /// </summary>
        static ApproveOfVolumes = new PkDocState(80, "Согласование объемов");

        /// <summary>
        /// Рассмотрение Наряд-заказа
        /// </summary>
        static OrderTicketReview = new PkDocState(81, "Рассмотрение Наряд-заказа");

        /// <summary>
        /// Расчет стоимости
        /// </summary>
        static CalculateOfCost = new PkDocState(82, "Расчет стоимости");

        /// <summary>
        /// Расчет объемов
        /// </summary>
        static CalculateOfVolumes = new PkDocState(83, "Расчет объемов");

        /// <summary>
        /// На согласовании у Директора продаж
        /// </summary>
        static ApproveWithSelesDirector = new PkDocState(84, "На согласовании у Директора продаж");

        /// <summary>
        /// На согласовании дирекции по строительству
        /// </summary>
        static ApproveWithConstructionDirectorate = new PkDocState(85, "На согласовании дирекции по строительству");

        /// <summary>
        /// На согласовании департаментом продаж
        /// </summary>
        static ApproveByTheSalesDepartment = new PkDocState(86, "На согласовании департаментом продаж");

        /// <summary>
        /// На согласовании делопроизводителем
        /// </summary>
        static ApproveByClerk = new PkDocState(87, "На согласовании делопроизводителем");

        /// <summary>
        /// Дубликат
        /// </summary>
        static Duplicate = new PkDocState(88, "Дубликат");

        /// <summary>
        /// У бухгалтера
        /// </summary>
        static AtTheAccountant = new PkDocState(89, "У бухгалтера");

        /// <summary>
        /// На подготовке к утверждению
        /// </summary>
        static PreparationForApproval = new PkDocState(90, "На подготовке к утверждению");

        /// <summary>
        /// На доработке у Заказчика
        /// </summary>
        static CompletionOfCustomer = new PkDocState(91, "На доработке у Заказчика");

        /// <summary>
        /// На согласовании стоимости
        /// </summary>
        static NegotiatingCost = new PkDocState(92, "На согласовании стоимости");

        /// <summary>
        /// Предпроект
        /// </summary>
        static PreProject = new PkDocState(93, "Предпроект");

        /// <summary>
        /// На подписании ГП
        /// </summary>
        static OnSigningGP = new PkDocState(94, "На подписании ГП");

        /// <summary>
        /// На подписании ГП исполнителя работ
        /// </summary>
        static OnSigningGPExecutorWorks = new PkDocState(95, "На подписании ГП исполнителя работ");

        /// <summary>
        /// На подписании Подрядчика
        /// </summary>
        static OnSigningContractor = new PkDocState(96, "На подписании Подрядчика");

        /// <summary>
        /// На подписании - Авторский надзор
        /// </summary>
        static OnSigningAuthorSupervision = new PkDocState(97, "На подписании - Авторский надзор");

        /// <summary>
        /// На подписании - Заказчик
        /// </summary>
        static OnSigningCustomer = new PkDocState(98, "На подписании - Заказчик");

        /// <summary>
        /// На подписании - Эксплуатирующая организация
        /// </summary>
        static OnSigningOperatingOrganization = new PkDocState(99, "На подписании - Эксплуатирующая организация");

        /// <summary>
        /// Конвертация
        /// </summary>
        static Converting = new PkDocState(100, "Конвертация");

        /// <summary>
        /// Обработка в ЕСУД завершена
        /// </summary>
        static EsudProcessingCompleted = new PkDocState(101, "Обработка в ЕСУД завершена");

        /// <summary>
        /// Ожидание обработки
        /// </summary>
        static WaitingProcessing = new PkDocState(102, "Ожидание обработки");

        /// <summary>
        /// Определение вида документа
        /// </summary>
        static DefineDocumentType = new PkDocState(103, "Определение вида документа");

        /// <summary>
        /// Передача в ЕСУД
        /// </summary>
        static EsudTransfer = new PkDocState(104, "Передача в ЕСУД");

        /// <summary>
        /// Успешно передано в ЕСУД
        /// </summary>
        static EsudTransferSuccessfully = new PkDocState(105, "Успешно передано в ЕСУД");

        /// <summary>
        /// Аннулирован в Диадок
        /// </summary>
        static DiadicRevocated = new PkDocState(106, "Аннулирован в Диадок");

        /// <summary>
        /// Отклонен в Диадок
        /// </summary>
        static DiadocRejected = new PkDocState(107, "Отклонен в Диадок");

        /// <summary>
        /// Подписан в Диадок
        /// </summary>
        static DiadocSigned = new PkDocState(108, "Подписан в Диадок");

        /// <summary>
        /// На рассмотрении РП
        /// </summary>
        static OnConsideringPM = new PkDocState(109, "На рассмотрении РП");

        /// <summary>
        /// На рассмотрении ПТО
        /// </summary>
        static OnConsideringPTO = new PkDocState(110, "На рассмотрении ПТО");

        /// <summary>
        /// Рассмотрение замечаний ПТО
        /// </summary>
        static ConsiderationOfPTOComments = new PkDocState(111, "Рассмотрение замечаний ПТО");

        /// <summary>
        /// Доработка замечаний РП, ПТО
        /// </summary>
        static RevisionPTOComments = new PkDocState(112, "Доработка замечаний РП, ПТО");

        /// <summary>
        /// Печать предварительного комплекта
        /// </summary>
        static PresetPrinting = new PkDocState(113, "Печать предварительного комплекта");

        /// <summary>
        /// Согласование в фонде реновации
        /// </summary>
        static ApprovalFundRenovation = new PkDocState(114, "Согласование в фонде реновации");

        /// <summary>
        /// Доработка замечаний от внешних организаций
        /// </summary>
        static FinalizeCommentsExternalOrganizations = new PkDocState(115, "Доработка замечаний от внешних организаций");

        /// <summary>
        /// На подготовке подрядчиком
        /// </summary>
        static OnPreparationContractor = new PkDocState(117, "На подготовке подрядчиком");

        /// <summary>
        /// Инициализация процесса согласования
        /// </summary>
        static InitializationApprovalProcess = new PkDocState(118, "Инициализация процесса согласования");

        /// <summary>
        /// На доработке поставщика
        /// </summary>
        static ReworkSupplier = new PkDocState(119, "На доработке поставщика");

        /// <summary>
        /// Выдано на руки
        /// </summary>
        static LentToHands = new PkDocState(120, "Выдано на руки");

        /// <summary>
        /// На согласование Субподрядчика
        /// </summary>
        static OnApprovalSubcontractor = new PkDocState(121, "На согласование Субподрядчика");

        /// <summary>
        /// На подписании Субподрядчика
        /// </summary>
        static OnSigningSubcontractor = new PkDocState(122, "На подписании Субподрядчика");

        /// <summary>
        /// На согласовании ген. директора
        /// </summary>
        static AgreementGeneralManager = new PkDocState(123, "На согласовании ген. директора");

        /// <summary>
        /// На согласовании финансиста
        /// </summary>
        static AgreementFinancier = new PkDocState(124, "На согласовании финансиста");

        /// <summary>
        /// На согласовании СМУ или ГИП/ПТО
        /// </summary>
        static AgreementSmuGipPto = new PkDocState(125, "На согласовании СМУ или ГИП/ПТО");

        /// <summary>
        /// На согласовании Зам. ГД по строительству
        /// </summary>
        static AgreementDeputyGD = new PkDocState(126, "На согласовании Зам. ГД по строительству");

        /// <summary>
        /// Требуется подписать извещение о получении
        /// </summary>
        static RequiresSigningNotice = new PkDocState(128, "Требуется подписать извещение о получении");

        /// <summary>
        /// Ошибка при подписании
        /// </summary>
        static SigningError = new PkDocState(129, "Ошибка при подписании");

        /// <summary>
        /// Требует подписания в Диадок
        /// </summary>
        static RequiresSigningInDiadoc = new PkDocState(130, "Требует подписания в Диадок");

        /// <summary>
        /// Запрошено аннулирование
        /// </summary>
        static RevocationRequested = new PkDocState(131, "Запрошено аннулирование");

        /// <summary>
        /// Получен запрос на аннулирование
        /// </summary>
        static RevocationRequestRecieved = new PkDocState(132, "Получен запрос на аннулирование");

        /// <summary>
        /// Отказано в запросе на аннулирование
        /// </summary>
        static RevocationRejected = new PkDocState(133, "Отказано в запросе на аннулирование");

        /// <summary>
        /// Отказано в подписи контрагенту
        /// </summary>
        static SignatureContragentRejected = new PkDocState(134, "Отказано в подписи контрагенту");

        /// <summary>
        /// У доп.согласующего
        /// </summary>
        static AtTheAdditionalApprover = new PkDocState(135, "У доп.согласующего");

        /// <summary>
        /// У Директора СМУ №4
        /// </summary>
        static DirectorSMU = new PkDocState(136, "У Директора СМУ №4");

        /// <summary>
        /// У Коммерческого директора
        /// </summary>
        static CommercialDirector = new PkDocState(137, "У Коммерческого директора");

        /// <summary>
        /// У Зам. ген. директора по СМР
        /// </summary>
        static DeputyDirectorSMR = new PkDocState(138, "У Зам. ген. директора по СМР");

        /// <summary>
        /// У 1-го зам.ген. директора
        /// </summary>
        static FirstDeputyDirector = new PkDocState(139, "У 1-го зам.ген. директора");

        /// <summary>
        /// Устранение замечаний
        /// </summary>
        static FixingProblems = new PkDocState(140, "Устранение замечаний");

        /// <summary>
        /// У ПТО подрядчика
        /// </summary>
        static AtPTOContractor = new PkDocState(141, "У ПТО подрядчика");

        /// <summary>
        /// Формирование ПДЦ
        /// </summary>
        static FormationPDC = new PkDocState(142, "Формирование ПДЦ");

        /// <summary>
        /// Отправка в архив
        /// </summary>
        static SendingToArchive = new PkDocState(150, "Отправка в архив");

        /// <summary>
        /// На согласовании - Инженер АН
        /// </summary>
        static OnApprovalASEngeneer = new PkDocState(152, "На согласовании - Инженер АН");

        /// <summary>
        /// На согласовании у Директора инициатора
        /// </summary>
        static OnApprovalDirectorOfInitiator = new PkDocState(201, "На согласовании у Директора инициатора");

        /// <summary>
        /// На согласовании у Директора по требованию
        /// </summary>
        static OnApprovalDirectorOnDemand = new PkDocState(202, "На согласовании у Директора по требованию");

        /// <summary>
        /// На согласовании у Контролера Комфорт
        /// </summary>
        static OnApprovalControllerComfort = new PkDocState(203, "На согласовании у Контролера Комфорт");

        /** Действует */
        static Operate = new PkDocState(204, "Действует");

        /** Доработка */
        static Modification = new PkDocState(205, "Доработка");

        /** Расторгнут */
        static Terminated = new PkDocState(206, "Расторгнут");

        /** Проверка учета замечаний перед отправкой */
        static CheckingCommentsBeforeSending = new PkDocState(207, "Проверка учета замечаний перед отправкой");
        
        /** На подписании в Диадок (внутри компании) */
        static OnSigningInDiadocInCompany = new PkDocState(208, "На подписании в Диадок (внутри компании)");

        /** На подписании в Диадок (у контрагента) */
        static OnSigningInDiadocWithPartner = new PkDocState(209, "На подписании в Диадок (у контрагента)");

        /** Подтверждение корректности подписания */
        static CheckSigningInDiadoc = new PkDocState(210, "Подтверждение корректности подписания");

        /** Доработка после подписания в диадок */
        static ModificationAfterSigningInDiadoc = new PkDocState(211, "Доработка после подписания в диадок");

        /** Подготовка документа к подписанию */
        static PreparationDocumentForSigning = new PkDocState(212, "Подготовка документа к подписанию");

        /** На подписании (внутри компании) */
        static OnSigningInCompany = new PkDocState(213, "На подписании (внутри компании)");

        /** На подписании (у контрагента) */
        static OnSigningAtPartner = new PkDocState(214, "На подписании (у контрагента)");

        /** Контроль возврата оригинала */
        static ControlReturnOriginal = new PkDocState(215, "Контроль возврата оригинала");

        /** Действующая */
        static CurrentVersion = new PkDocState(250, "Действующая");

        /** Отозвана */
        static Recalled = new PkDocState(251, "Отозвана");

        /** Истек срок действия */
        static Expired = new PkDocState(252, "Истек срок действия");

        /** Заполнение сумм */
        static SetAmount = new PkDocState(253, "Заполнение сумм");

        /** На подписании DSS */
        static OnDssSigning = new PkDocState(254, "На подписании DSS");

        /** На аннулировании */
        static OnRevocation = new PkDocState(294, "На аннулировании");

        /** Перезапуск процессов */
        static RestartingProcesses = new PkDocState(295, "Перезапуск процессов");

        /** Подписан и согласован */
        static SignedAndApproved = new PkDocState(296, "Подписан и согласован");

        /** Утратил силу */
        static LostForces = new PkDocState(297, "Утратил силу");
        
        /** На сопоставлении */
        static OnMatching = new PkDocState(298, "На сопоставлении");

        /** Ожидание родительского документа */
        static WaitMainDocument = new PkDocState(299, "Ожидание родительского документа");
        
        /** Создано КСД */
        static CreatedKSD = new PkDocState(300, "Создано КСД");

        /** Формирование КСД */
        static FormationKSD = new PkDocState(301, "Формирование КСД");

         /** Устранение замечений*/
         static FixProblems = new PkDocState(302, "Устранение замечений");

          /** Подтверждение передачи документов */
        static ConfirmTransferDocument = new PkDocState(303, "Подтверждение передачи документов");

        /** Доработка для специалиста первичного контроля закупок */
        static EditSpecialistPrimaryProcurementControl = new PkDocState(304, "Доработка для специалиста первичного контроля закупок");

        /** Присвоен номер. */
        static NumberAssigned = new PkDocState(306, "Присвоен номер");

        /** Отправлено. */
        static HasBeenSent = new PkDocState(307, "Отправлено");

        /** Доставлено. */
        static Delivered = new PkDocState(308, "Доставлено");

        /** Готов к отправке. */
        static ReadyToSend = new PkDocState(309, "Готов к отправке");

        /** Отправлен из УДО. */
        static SentFromUdo = new PkDocState(310, "Отправлен из УДО");

        /** Отправлен Почтой России. */
        static SentByRussianPost = new PkDocState(311, "Отправлен Почтой России");

        /** Выполнено. */
        static Done = new PkDocState(313, "Выполнено");

        /** Не выполнено. */
        static NotDone = new PkDocState(314, "Не выполнено");

        /** Не доставлено. */
        static NotDelivered = new PkDocState(315, "Не доставлено");

        /** Не отправлено. */
        static NotSent = new PkDocState(316, "Не отправлено");

        /** Актуальный. */
        static Actual = new PkDocState(325, "Актуальный");

        /** Архивный. */
        static Archived = new PkDocState(324, "Архивный");

        /** Ожидает проверки. */
        static PendingVerification = new PkDocState(328, "Ожидает проверки");

        /// <summary>
        /// Ошибка подписания
        /// </summary>
        static ErrorSigning = new PkDocState(329, "Ошибка подписания");
}